import { ReactElement } from "jsx-dom";

export const Alert = ({ text }: { text: string | ReactElement }) => {
  return (
    <div class="tw:p-3 tw:bg-fruugo-light-red tw:border-l-2 tw:border-l-fruugo-red tw:rounded tw:text-fruugo-black">
      <p class="tw:m-0">{text}</p>
    </div>
  );
};
